import React from "react"
import { Button } from "react-bootstrap"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `StaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `StaticQuery`: https://gatsby.dev/staticquery
 */

const ButtonSignup = ({style}) => (
  <Button primary
    className="demo-button"
    style = {{
      color: `white`,
      fontWeight: `bold`,
      paddingLeft: `30px`,
      paddingRight: `30px`,
      ...style
    }}
    href = "https://app.babblestack.com/signup"
  >
    Sign Up Free
  </Button>
)
export default ButtonSignup
